import type { PaginationMeta } from '@core/http-types';

export const isAllPagesLoaded = (pagination: PaginationMeta) =>
  pagination.totalCount <= pagination.page * pagination.limit;

export const isFilteredEmptyState = (
  isViewPredefined: boolean,
  filtersApplied: boolean,
  filtersChanged: boolean,
): boolean => {
  if (!isViewPredefined && filtersApplied) return true;

  return isViewPredefined && filtersChanged;
};
